<template>
	<div class="rounded-[4px] border bg-white-neutral shadow-md">
		<p class="font-medium text-gray-medium p-2 text-lg">Colunas</p>
		<span
			class="text-blue-base p-2 cursor-pointer"
			@click="selecionarTodas"
			>selecionar todas</span
		>
		<div
			v-for="coluna in options"
			:key="coluna.value"
			class="flex border-b p-2 gap-2"
		>
			<Checkbox
				v-model="value"
				:value="coluna.value"
			/>
			<p class="text-gray-dark font-normal">
				{{ coluna.label }}
			</p>
		</div>
	</div>
</template>

<script setup>
import Checkbox from '../../Checkbox/Checkbox.vue'
const emit = defineEmits(['input'])

const props = defineProps({
	options: {
		type: Array,
		required: true,
	},
	value: {
		type: Array,
		default: () => [],
	},
})

function selecionarTodas() {
	emit(
		'input',
		props.options.map((m) => m.value),
	)
}
</script>

<style></style>
